import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgImport = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M5.05 16C2.81328 16 1 14.1283 1 11.8214C1 9.99914 2.12972 8.44957 3.70561 7.87802C3.70191 7.79973 3.70004 7.72135 3.7 7.64296C3.7 5.07758 5.71379 3 8.2 3C9.8678 3 11.322 3.9357 12.101 5.3273C12.5284 5.00517 13.046 4.85719 13.6 4.85719C15.0906 4.85719 16.3 6.07873 16.3 7.64281C16.3 7.99684 16.2354 8.33348 16.12 8.64684C17.7624 8.98922 19 10.4895 19 12.2859C19 14.3372 17.3884 16 15.4 16H5.05ZM7.27197 9.70316C7.01038 9.97586 7.01038 10.417 7.27197 10.6637C7.53621 10.9596 7.96379 10.9596 8.20295 10.6637L9.325 9.55517V13.4464C9.325 13.8323 9.62598 14.1428 10 14.1428C10.374 14.1428 10.675 13.8323 10.675 13.4464V9.55517L11.7718 10.6637C12.0362 10.9596 12.4638 10.9596 12.7028 10.6637C12.9896 10.417 12.9896 9.97586 12.7028 9.70316L10.453 7.38176C10.2139 7.11178 9.78636 7.11178 9.52197 7.38176L7.27197 9.70316Z",
		fill: "#0D2976"
	})
});
export default SvgImport;
